import React, { forwardRef, Component } from 'react';
import { motion } from 'framer-motion';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'flat' | 'outlined';
  isClickable?: boolean;
  noPadding?: boolean;
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className = '',
  variant = 'default',
  isClickable = false,
  noPadding = false,
  children,
  ...props
}, ref) => {
  const variants = {
    default: 'bg-surface-primary shadow-elevation-1 border border-border-light',
    flat: 'bg-surface-secondary border border-transparent',
    outlined: 'bg-surface-primary border border-border-default'
  };
  const padding = noPadding ? '' : 'p-5';
  const clickableStyles = isClickable ? 'cursor-pointer hover:shadow-elevation-2 transition-shadow duration-200' : '';
  const Component = isClickable ? motion.div : 'div';
  return <Component ref={ref} whileHover={isClickable ? {
    y: -2
  } : undefined} className={`rounded-fluent-lg ${variants[variant]} ${padding} ${clickableStyles} ${className}`} {...props} data-id="element-170">
        {children}
      </Component>;
});
Card.displayName = 'Card';